import React, { useState } from "react";
import { RevokeAdmin } from "../../pages";
import { AdminController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import { adminStore } from "../../stores";
import { toJS } from "mobx";

const RevokeAdminContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);

    const onSubmit = async (payload) => {
        setLoading(true);       
        for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}

        const { status, errorMessage } = await AdminController.revokeAdminPermission(
            payload,
            data._id
        )        

        if (status === constant.Success) {   
            setLoading(false);        
            if (data.status === "INACTIVE") {
                MimaToastUtil.success({ message: 'Admin approved' })
            } else if (data.status === "ACTIVE") {
                MimaToastUtil.error({ message: 'Admin Revoked' })
            }
            await AdminController.getAdminUsers()
            return closeModal();
        }   
        setLoading(false); 
        MimaToastUtil.error({ message: errorMessage });
    }

    return (
        <RevokeAdmin        
        data={data}
        loading={loading} 
        onSubmit={onSubmit}
        closeModal={closeModal}
        />
    )
}
export default RevokeAdminContainer;